import React, { useState } from 'react';
import Modal from './Modal'; // Giả sử bạn đã tạo một component Modal

const Statistical = ({ statisticalData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentUsers, setCurrentUsers] = useState([]);

  const acceptedUsers =
    statisticalData?.users?.details?.accepted.listIdUser.filter(Boolean) || [];
  const rejectedUsers =
    statisticalData?.users?.details?.rejected.listIdUser?.filter(Boolean) || [];

  // Create a set to avoid duplicates
  const uniqueRejectedUsers = rejectedUsers.filter(
    (user) => !acceptedUsers.includes(user)
  );

  const handleShowAcceptedUsers = () => {
    setCurrentUsers(acceptedUsers);
    setIsModalOpen(true);
  };

  const handleShowRejectedUsers = () => {
    setCurrentUsers(uniqueRejectedUsers);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="w-1/8 bg-white rounded-lg shadow-sm dark:bg-gray-700 h-fit">
      <div className="flex flex-col gap-2 p-3">
        <div className="p-2 bg-blue-50 rounded dark:bg-gray-600 text-center">
          <p className="text-xs font-medium">Tổng số</p>
          <p className="text-lg font-bold">
            {statisticalData.postResults?.totalsPost || 0}
          </p>
        </div>
        <div className="p-2 bg-yellow-50 rounded dark:bg-gray-600 text-center">
          <p className="text-xs font-medium">Chờ duyệt</p>
          <p className="text-lg font-bold">
            {statisticalData.postResults?.totalsPostWaiting || 0}
          </p>
        </div>
        <div className="p-2 bg-green-50 rounded dark:bg-gray-600 text-center">
          <p className="text-xs font-medium">Đã duyệt</p>
          <p className="text-lg font-bold">
            {statisticalData.postResults?.totalsPostAccepted || 0}
          </p>
        </div>
        <div className="p-2 bg-red-50 rounded dark:bg-gray-600 text-center">
          <p className="text-xs font-medium">Từ chối</p>
          <p className="text-lg font-bold">
            {statisticalData.postResults?.totalsPostRejected || 0}
          </p>
        </div>
        <div className="p-2 bg-orange-50 rounded dark:bg-gray-600 text-center">
          <p className="text-xs font-medium">Đã hủy</p>
          <p className="text-lg font-bold">
            {statisticalData.postResults?.totalsPostCanceled || 0}
          </p>
        </div>
        <div className="mt-2 border-t pt-2">Thống kê người dùng</div>
        <div className="text-sm text-center text-gray-600 dark:text-gray-300 ">
          Số người dùng đã đăng: {statisticalData.users?.totalsUserPosted || 0}
        </div>

        <div
          className="p-2 bg-orange-50 rounded dark:bg-gray-600 text-center cursor-pointer"
          onClick={handleShowAcceptedUsers}
        >
          <p className="text-xs font-medium">Đã Duyệt</p>
          <p className="text-lg font-bold">{acceptedUsers.length}</p>
        </div>
        <div
          className="p-2 bg-orange-50 rounded dark:bg-gray-600 text-center cursor-pointer"
          onClick={handleShowRejectedUsers}
        >
          <p className="text-xs font-medium">Từ chối</p>
          <p className="text-lg font-bold">{uniqueRejectedUsers.length}</p>
        </div>
      </div>

      {/* Modal để hiển thị danh sách người dùng */}
      <Modal isOpen={isModalOpen} onClose={closeModal} users={currentUsers} />
    </div>
  );
};

export default Statistical;
